import {makeStyles} from '@material-ui/core';
import React from 'react';
import logo from './img/SHLL Colour RGB.png';

const useStyles = makeStyles({
    root: {
        padding: '.6rem',
        textAlign: 'center',
        display: "flex",
        justifyContent: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
        fontWeight: 500,
        fontSize: 40,
    },
    logo: {
        width: 100,
        marginRight: '1rem'
    }
});


const Header = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <img alt={'Logo'} src={logo} className={classes.logo}/>Health Literacy Editor
        </div>
    );
};


export default Header;